var map = {
	"./Base.vue": 5712,
	"./Birthdate/Confirmation.vue": 76275,
	"./Birthdate/Display.vue": 78056,
	"./Birthdate/Particles.vue": 75279,
	"./Birthdate/ParticlesAlt.vue": 38636,
	"./Birthdate/SelectDay.vue": 31824,
	"./Birthdate/SelectMonth.vue": 69424,
	"./Birthdate/SelectYear.vue": 80518,
	"./Birthdate/Selector.vue": 19263,
	"./Branding/Logo.vue": 53392,
	"./Button/Cancel.vue": 9573,
	"./Button/CelestialClose.vue": 73856,
	"./Button/Clear.vue": 69023,
	"./Button/Close.vue": 88024,
	"./Button/ConfirmBirthdate.vue": 5707,
	"./Button/ConfirmDay.vue": 78615,
	"./Button/ConfirmMonth.vue": 58996,
	"./Button/ConfirmYear.vue": 32731,
	"./Button/Continue.vue": 61745,
	"./Button/Download.vue": 79665,
	"./Button/EnterBirthday.vue": 46126,
	"./Button/Menu.vue": 22045,
	"./Button/ReceiveFortune.vue": 47324,
	"./Button/RejectBirthdate.vue": 55388,
	"./Button/Restart.vue": 19692,
	"./Button/Save.vue": 8372,
	"./Button/SelectColor.vue": 84773,
	"./Button/SelectLanguage.vue": 83804,
	"./Button/SelectShape.vue": 56540,
	"./Button/Share.vue": 74905,
	"./Button/Skip.vue": 14941,
	"./Button/ToggleAudio.vue": 83534,
	"./Button/TryAgain.vue": 59658,
	"./CardStack.vue": 81382,
	"./Character/Bunny.vue": 88528,
	"./Character/Dragon.vue": 91668,
	"./Conversation/Answer/ColorSelector.vue": 19392,
	"./Conversation/Answer/Emoji.vue": 5169,
	"./Conversation/Answer/EmojiImage.vue": 75918,
	"./Conversation/Answer/Shape.vue": 94902,
	"./Conversation/Answer/Text.vue": 90334,
	"./Conversation/Characters.vue": 11389,
	"./Conversation/Dialogue.vue": 16343,
	"./Conversation/Interaction.vue": 49746,
	"./Conversation/Interaction/Color.vue": 61697,
	"./Conversation/Interaction/Grower.vue": 33499,
	"./Conversation/Interaction/MultipleChoice.vue": 36838,
	"./CosmicText.vue": 52293,
	"./Debug.vue": 64783,
	"./Envelope.vue": 69679,
	"./Global/About.vue": 67871,
	"./Global/Footer.vue": 71120,
	"./Global/Header.vue": 60331,
	"./Global/Starfield.vue": 99591,
	"./Global/StarfieldBasic.vue": 83423,
	"./Graphic/BirthdayHelper.vue": 69163,
	"./Graphic/PinchGesture.vue": 21622,
	"./Graphic/ScrollGesture.vue": 98933,
	"./Graphic/SlideGesture.vue": 30088,
	"./Graphic/SwipeGesture.vue": 30405,
	"./Graphic/TapGesture.vue": 59784,
	"./Intro.vue": 38746,
	"./LanguageSelection.vue": 2336,
	"./Outro.vue": 25131,
	"./Ribbon.vue": 27734,
	"./SpeechBubble.vue": 46645,
	"./Stars.vue": 98759,
	"./TiltableCard.vue": 9838,
	"./Welcome.vue": 70314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78756;